import { fmtDeliverableType } from '@discovr/types';
import type { OutreachRow } from '@discovr/types';
import { fmtAgreedItem } from './agreedMoney';

/** Styles "Discovery" inline within an empty-state body (Figma's link-
 *  colored word) — derived from the one copy string in INBOX_EMPTY_COPY
 *  rather than a second, hand-duplicated copy of the sentence. A no-op for
 *  bodies that don't mention it. */
export function emphasizeDiscovery(body: string): React.ReactNode {
  const idx = body.indexOf('Discovery');
  if (idx === -1) return body;
  return (
    <>
      {body.slice(0, idx)}
      <span className="font-medium text-primary">Discovery</span>
      {body.slice(idx + 'Discovery'.length)}
    </>
  );
}


/** basePrice is the INR figure; a converted rate shows the creator's original beside it. */
export function fmtAgreed(deliverables?: OutreachRow['agreedDeliverables']): string {
  if (!deliverables || deliverables.length === 0) return '';
  return deliverables.map((d) => `${fmtAgreedItem(d)} ${fmtDeliverableType(d.type)}`).join(' · ');
}
